export const PENALTY = [
    { name: 'Fortified Bond', value: 'fortifiedBond' },
    { name: 'Collateral', value: 'collateral' }
];